<template>
  <div>
    <div
      v-if="loading"
      class="col-md-12 text-center"
      style="margin-top:25%"
    >
      <PulseLoader
        :loading="loading"
      ></PulseLoader>
    </div>
    <div v-if="!loading">
      <div class="row">
        <div class="col-md-12 col-sm-12 ">
          <div class="">
            <div class="x_panel">
              <h2 class="float-left">Profile</h2>
              <ul class="nav navbar-right panel_toolbox align-right">

                <li>
                  <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
                </li>
              </ul>
            </div>
            <div class="row">
              <div class="col-12 col-md-8">
                <div class="card">
                  <div class="card-body">
                    <form @submit.prevent="update()" @keydown="form.onKeydown($event)">
                      <div class="modal-body">
                        <!-- <alert-error :form="form"></alert-error> -->
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>User Name</label>
                              <input autocomplete="off" v-model="form.username" type="text" name="username" class="form-control" :class="{ 'is-invalid': form.errors.has('username') }">
                              <has-error :form="form" field="username"></has-error>
                            </div>
                            <div class="form-group">
                              <label>Email : </label>
                              <input autocomplete="off" v-model="form.email" type="text" name="email" class="form-control" :class="{ 'is-invalid': form.errors.has('email') }">
                              <has-error :form="form" field="email"></has-error>
                            </div>
                            <div class="form-group">
                              <label> License Number</label>
                              <input autocomplete="off" v-model="form.license_number" type="text" name="license_number" class="form-control" :class="{ 'is-invalid': form.errors.has('license_number') }">
                              <has-error :form="form" field="license_number"></has-error>
                            </div>

                            <div class="form-group">
                              <label> Nationality</label>
                              <select v-model="form.nationality" name="nationality" class="form-control" :class="{ 'is-invalid': form.errors.has('nationality') }">
                                <option value="" selected>Select Nationality</option>
                                <option v-for="country in countryes" :key="country.id" :value="country.id">{{country.name}}</option>
                              </select>
                              <has-error :form="form" field="nationality"></has-error>
                            </div>

                            <div class="form-group">
                              <label>License Issuing Country</label>
                              <select v-model="form.liscense_issuing_country" name="liscense_issuing_country" class="form-control" :class="{ 'is-invalid': form.errors.has('liscense_issuing_country') }">
                                <option value="" selected>Select Country</option>
                                <option v-for="country in countryes" :key="country.id" :value="country.id">{{country.name}}</option>
                              </select>
                              <has-error :form="form" field="liscense_issuing_country"></has-error>
                            </div>

                            <div class="form-group">
                              <label>License Validity </label><br>
                              <DatePicker type="date" v-model="form.license_validaty" name="license_validaty" valueType="format"></DatePicker>
                              <has-error :form="form" field="license_validaty"></has-error>
                            </div>

                            <div class="form-group">
                              <label>License Endorsement No by Flag </label>
                              <input autocomplete="off" v-model="form.license_endorsement_number" type="text" name="license_endorsement_number" class="form-control" :class="{ 'is-invalid': form.errors.has('license_endorsement_number') }">
                              <has-error :form="form" field="license_endorsement_number"></has-error>
                            </div>

                          </div>
                          <div class="col-md-6">

                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>Photo </label>
                                  <div>
                                    <img height="100" width="200"
                                         v-if="userData && userData.user_detail && userData.user_detail.photo != null"
                                         :src="userData && userData.user_detail && userData.user_detail.photo" alt="">
                                  </div>
                                  <input type="file" name="signature" class="form-control des" @change="covertPhoto" accept=".png, .jpg, .jpeg">
                                  <has-error :form="form" field="signature"></has-error>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <span class="mb-3">Preview</span>
                                <img v-if="uploadedPhoto" class="file-upload-image" :src="uploadedPhoto" alt="your image"/>
                              </div>
                            </div>

                            <div class="form-group">
                              <label>Certificate </label>
                              <div>
                                <img height="100" width="200"
                                     v-if="userData && userData.user_detail && userData.user_detail.certificate != null"
                                     :src="userData && userData.user_detail && userData.user_detail.certificate" alt="">
                              </div>
                              <input type="file" name="certificate" class="form-control des" @change="covertCertificate" accept=".png, .jpg, .jpeg">
                              <has-error :form="form" field="certificate"></has-error>
                            </div>

                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>Signature </label>
                                  <div>
                                    <img height="100" width="200"
                                         v-if="userData && userData.user_detail && userData.user_detail.signature != null"
                                         :src="userData && userData.user_detail && userData.user_detail.signature" alt="">
                                  </div>
                                  <input type="file" name="signature" class="form-control des" @change="covertSignature" accept=".png, .jpg, .jpeg">
                                  <has-error :form="form" field="signature"></has-error>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <span class="mb-3">Preview</span>
                                <img v-if="uploadedSignature" class="file-upload-image" :src="uploadedSignature" alt="your image"/>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button :disabled="form.busy" type="submit" class="btn btn-info">Save</button>
                      </div>
                    </form>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
  <!-- Modal -->

</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import auth from "@/auth";
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";

    export default {
        components: {DatePicker, PulseLoader},
        mixins: [goBackButtonMixin],
        name: "MyProfile",
        data() {
            return {
              loading: false,
              uploadedSignature: '',
              uploadedPhoto: '',
              userData: {},
              countryes: [],
              form: new Form({
                  username: "",
                  email: '',
                  license_number: '',
                  nationality: '',
                  liscense_issuing_country: '',
                  license_endorsement_number: '',
                  license_validaty: '',
                  certificate: "",
                  photo: "",
                  signature: '',
                }),

            };
        },
        mounted() {
          this.userInfo();
          this.allCountry()
        },
        methods: {
          update() {
                this.form.busy = true;
                this.form.post("/api/update-my-profile").then(response => {
                    if (this.form.successful) {
                        this.$snotify.success("Profile Update Successfully");
                    } else {
                        this.$snotify.error(
                            "Something went wrong try again later.",
                            "Error"
                        );
                    }
                }).catch(e => {
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                    if (response.status === 422) {
                        if (response.data?.errors) {
                            const errors = response.data.errors;
                            for (const key in errors) {
                                this.$snotify.error(errors[key][0])
                            }
                        }
                    } else {
                        this.$snotify.error(response?.data?.error)
                    }
                });
            },
          allCountry() {
            //  country
            this.$http.get("/api/country").then(response => {
              this.countryes = response.data.success;
              setTimeout(() => $('#datatables').DataTable(), 1000);
            }).catch(e => {
              console.log(e);
            });
          },
          userInfo() {
            this.$http.post('/api/user-details').then(response => {
              let data = response.data.success;
              this.form.username = data.username;
              this.form.email = data.email;
              this.form.license_number = data?.user_detail?.license_number;
              this.form.nationality = data?.user_detail?.nationality;
              this.form.license_endorsement_number = data?.user_detail?.license_endorsement_number;
              this.form.license_validaty = data?.user_detail?.license_validaty;
              this.form.liscense_issuing_country = data?.user_detail?.liscense_issuing_country;
              this.userData = data;
            }).catch(error => {
            })
          },

          covertSignature(event) {
            let file = event.target.files[0];
            this.form.signature = file;
            this.uploadedSignature = URL.createObjectURL(file);
          },
          covertCertificate(event) {
            let file = event.target.files[0];
            this.form.certificate = file;
          },
          covertPhoto(event) {
            let file = event.target.files[0];
            this.form.photo = file;
            this.uploadedPhoto = URL.createObjectURL(file)
          },


        }
    }
</script>

<style scoped>
  .mx-datepicker {
    width: 100% !important;
  }

  .des {
    height: 36% !important;
  }
</style>
